import { useMemo } from 'react';

import { getPollStatuses } from '../resources/pollStatuses';
import type { PollType } from '../types';

export const usePollStatus = (poll: PollType | null) => useMemo(() => getPollStatuses(poll), [poll]);
